<template>
	<div>
		<CommonFlame :title="`負荷一覧`" :maxWidth="'auto'">
			<GanttChart
				:taskTitle="'製造番号'"
				:tasks="ganttChartInfos"
				:taskNameKey="'id'"
				:startDateKey="'start_date'"
				:endDateKey="'end_date'"
				:fontSize="fontSize"
				:topSectionPosition="'right'"
				:isWindowSizeCheck="isWindowSizeCheck"
				:isDraggable="false"
				:taskBarStyle="taskBarStyle"
				:taskBarNameStyle="taskBarNameStyle"
				:colorRecognitionKey="'situation'"
				:taskBarColorsByRecognitionKey="taskBarColorsByRecognitionKey"
				:taskBarType="'bar'"
				:changeDatetimeFlag="false"
				:taskClickable="false"
				:display_date.sync="display_date"
				:start_date="start_date"
				:end_date="end_date"
				:dateChartSpanUnit="'months'"
				:dateChartSpan="3"
				:topDateUnitHeight="topDateUnitHeight"
				showDates
				onlyDateChartType
			>
				<template v-slot:app-bar-btn>
					<v-row no-gutters justify="end" align="baseline">
						<div
							v-for="(situation, i) in situations"
							class="px-1 text-body-2 mt-sm-0 mt-2"
							:key="i"
						>
							<span :style="{ color: taskBarColorsByRecognitionKey[situation.value] }"> ● </span>
							{{ situation.name }}
						</div>
					</v-row>
				</template>
				<!-- <template v-slot:task-top-section="{ taskTitle }">
					<v-col :cols="12" class="gantt-task">{{ taskTitle }}</v-col>
				</template> -->
				<template v-slot:task-list-name="{ task }">
					<span class="text-body-2" v-text="common.productNumberByOrderIndividualInfo(task)">
					</span>
				</template>
				<template v-slot:task-name="{ task }">
					{{ common.productNumberByOrderIndividualInfo(task) }}
				</template>
				<template v-slot:top-date-unit="{ date }">
					<div
						:style="{ ...colorByLoadFactor(date), height: `${topDateUnitHeight}px` }"
						class="top-date-unit"
					>
						<span> {{ loadFactor(date) }}% </span>
					</div>
				</template>
			</GanttChart>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import common from "../../helper/common"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import CommonFlame from "../shared/CommonFlame.vue"
import GanttChart from "../shared/MultipleLineGanttChart.vue"

export default {
	components: {
		CommonFlame,
		GanttChart,
	},
	data() {
		return {
			common,
			orderIndividualInfos: [],
			ganttChartInfos: [],
			areas: [],
			situations: [
				{ value: "order_received", name: "受注済み" },
				{ value: "shipped", name: "出荷済み" },
				{ value: "situation_a", name: "受注確度A" },
				{ value: "situation_b", name: "受注確度B" },
			],
			authorized: false,
			isWindowSizeCheck: false,
			fontSize: "14px",
			tdStyle: {
				textAlign: "left",
			},
			selectedItem: {
				id: null,
			},
			taskBarStyle: {
				textAlign: "center",
				height: "24px",
				paddingBottom: "4px",
				borderRadius: 0,
			},
			taskBarNameStyle: {
				fontSize: ".9rem",
				color: "black",
			},
			taskBarColorsByRecognitionKey: {
				order_received: this.$vuetify.theme.themes.light.load_factor.order_received,
				shipped: this.$vuetify.theme.themes.light.load_factor.shipped,
				situation_a: this.$vuetify.theme.themes.light.load_factor.situation_a,
				situation_b: this.$vuetify.theme.themes.light.load_factor.situation_b,
			},
			fetchedMonths: [],
			display_date: null,
			start_date: null,
			end_date: null,
			topDateUnitHeight: 32, // 表示する負荷率ボックスの高さ
		}
	},
	mounted() {
		let start_date
		let end_date
		if (this.$route.query.start_date) {
			this.start_date = moment(this.$route.query.start_date).startOf("month").format("YYYY-MM-DD")
			this.end_date = moment(this.start_date).add(2, "months").endOf("month").format("YYYY-MM-DD")
		} else {
			this.start_date = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD")
			this.end_date = moment(this.start_date).add(2, "months").endOf("month").format("YYYY-MM-DD")
		}
		this.setFetchedMonths()

		this.fetchOrderIndividualInfos(
			true,
			start_date ? start_date : this.start_date,
			end_date ? end_date : this.end_date
		)
	},

	methods: {
		fetchOrderIndividualInfos(first_visit, start_date = null, end_date = null) {
			const headers = authenticate.setHeader()
			const params = {
				start_date: start_date ? start_date : this.start_date,
				end_date: end_date ? end_date : this.end_date,
				first_visit,
			}
			const url = `/erp/v1/areas/order_individual_infos`
			axios
				.get(url, { headers, params })
				.then((res) => {
					this.orderIndividualInfos = res.data.order_individual_infos.map((o) => {
						o.situation = this.setSituation(o)
						o.start_date = 'TODO'
						o.end_date = 'TODO'
						return o
					})

					if (first_visit) {
						this.areas = res.data.areas
					}
					this.setGanttChartInfos()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setSituation(order_individual_info) {
			// TODO ここで、order_individual_infoのsituationを設定する 現在はランダム
			return 
		},
		loadFactor(date) {
			return Math.floor(Math.random() * 100)
			// TODO 日にちとエリアで負荷率を計算する
		},
		colorByLoadFactor(date) {
			const loadFactor = this.loadFactor(date)
			if (loadFactor < 50) {
				return { backgroundColor: "green", color: "white", width: "100%", height: "100%" }
			} else if (loadFactor < 80) {
				return { backgroundColor: "orange", color: "white", width: "100%", height: "100%" }
			} else {
				return { backgroundColor: "orangered", color: "white", width: "100%", height: "100%" }
			}
		},
		setFetchedMonths() {
			let months = []
			let currentDate = moment(this.start_date).startOf("month")

			while (currentDate.isBefore(this.end_date)) {
				months.push(currentDate.format("YYYY-MM"))
				currentDate.add(1, "month")
			}
			months.forEach((m) => {
				if (!this.fetchedMonths.includes(m)) {
					this.fetchedMonths.push(m)
				}
			})
		},
		changeDisplayDate(date) {
			this.start_date = date.start_date
			this.end_date = date.end_date
			let months = this.checkFetchedMonths(this.start_date, this.end_date)
			if (months.length > 0) {
				this.setFetchedMonths()
				this.fetchOrderIndividualInfos(false, months[0], months[months.length - 1])
			} else {
				this.setGanttChartInfos()
			}
			let query = {
				...this.q,
				start_date: this.start_date,
				end_date: this.end_date,
				process_type_id: this.selectedTypeId,
			}
			// 現在のクエリと新しいクエリを比較し、異なる場合に遷移する
			if (JSON.stringify(this.$route.query) === JSON.stringify(query)) return
			this.$router.push({
				name: this.$route.name,
				query,
			})
		},
		checkFetchedMonths(start_date, end_date) {
			let months = []
			let currentDate = moment(start_date).startOf("month")
			while (currentDate.isBefore(end_date)) {
				months.push(currentDate.format("YYYY-MM"))
				currentDate.add(1, "month")
			}
			const notFetchedMonths = months.filter((m) => !this.fetchedMonths.includes(m))
			if (notFetchedMonths.length == 0) return []
			const dates = [
				moment(notFetchedMonths[0]).startOf("month").format("YYYY-MM-DD"),
				moment(notFetchedMonths[notFetchedMonths.length - 1])
					.endOf("month")
					.format("YYYY-MM-DD"),
			]
			return dates
		},
		setGanttChartInfos() {
			this.ganttChartInfos = this.orderIndividualInfos.filter((info) => {
				return (
					moment(info.start_date).isBetween(this.start_date, this.end_date, null, "[]") ||
					moment(info.end_date).isBetween(this.start_date, this.end_date, null, "[]")
				)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.task-time {
	position: relative;
	text-align: center;
	font-size: 0.85rem;
	border-right: solid 1px #80808045;
	.edit-icon-btn {
		position: absolute;
		top: 4px;
		right: 4px;
	}
}
.top-date-unit {
	position: relative;
	display: flex;
	text-align: center;
	align-items: center;
	span {
		text-align: center;
	}
}
</style>